import { Audio } from '../audio-card-section/AudioCardSection';

// TODO: Replace with actual tracks and IDs
export const tracks: Audio[] = [
  {
    name: 'Back on Track',
    image: '/images/gen-ai/bg-music-back-on-track.png',
    audio:
      'https://adstudio-assets.scdn.co/wav/da7eb8aeaba7d003d01d3943eedba3a42bc07a19.wav',
    audioId: 'b420ff18-1cf6-447e-9f0c-9eaf46279adb',
  },
  {
    name: 'Counterbalanced',
    image: '/images/gen-ai/bg-music-counterbalanced.png',
    audio:
      'https://adstudio-assets.scdn.co/wav/1522c8551b05cd8c01448656b9f73c683615a75e.wav',
    audioId: '53d3e0e5-0ccc-4700-b793-4b02a57bfcae',
  },
  {
    name: 'Ladies First',
    image: '/images/gen-ai/bg-music-ladies-first.png',
    audio:
      'https://adstudio-assets.scdn.co/wav/142e41ebfecea23c0dceb58fee3b8d16423b1c7d.wav',
    audioId: '2d4f8c7b-21c3-455d-b03b-2e59c44e9b9a',
  },
  {
    name: 'Leave Me Out',
    image: '/images/gen-ai/bg-music-leave-me-out.png',
    audio:
      'https://adstudio-assets.scdn.co/wav/61ca1cfd0846ab964f8112a88ce72516c35af5f7.wav',
    audioId: '0106a2e0-3fc5-46bb-85f9-e56e63968a41',
  },
];
